import Vue from 'vue'
import Router from 'vue-router'
import Inbox from '@/components/Inbox'
import Login from '@/components/Login'
import MisFeedbacks from '../components/MisFeedbacks'
import ReporteFeedbacks from '@/components/ReporteFeedbacks'
import ReporteObjetivos from '@/components/ReporteObjetivos'
import FeedbackDetail from '@/components/FeedbackDetail'
import FeedbackDetailAdmin from '@/components/FeedbackDetailAdmin'
import AcuerdoDeObjetivos from '@/components/AcuerdoDeObjetivos'
import SetObjetivos from '@/components/SetObjetivos'
import firebase from '../firebase-config'
import AcuerdoDetail from '@/components/AcuerdoDetail'
import MisObjetivos from '@/components/MisObjetivos'
import MisMeritos from '@/components/MisMeritos'

import FluxerService from '../services/fluxer'

Vue.use(Router)

function requireAuth (to, from, next) {
  if (typeof FluxerService.getCurrentUser() !== 'object') {
    console.log('User is not logged in')
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    const localKey = Object.keys(localStorage).find(f => f.match(/firebase:host.*/gm))
    const lastDate = new Date(parseInt(JSON.parse(localStorage[localKey]).lastLoginAt))
    const truncateDate = new Date(new Date('2019-11-26').setHours(14))
    if (lastDate.getTime() < truncateDate) {
      localStorage.clear()
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      console.log('Session is okey! :)')
      next()
    }
  }
}

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'inbox',
      component: Inbox,
      beforeEnter: requireAuth,
      children: [
        {
          path: 'feedback/:id',
          name: 'feedback-detail',
          component: FeedbackDetail
        }
      ]
    },
    {
      path: '/proceso',
      name: 'mis-feedbacks',
      component: MisFeedbacks,
      beforeEnter: requireAuth,
      children: [
        {
          path: 'mi-feedback/:id',
          name: 'mi-feedback-detail',
          component: FeedbackDetail
        }
      ]
    },
    {
      path: '/acuerdo-objetivos',
      name: 'acuerdo-objetivos',
      component: AcuerdoDeObjetivos,
      beforeEnter: requireAuth,
      children: [
        {
          path: 'acuerdo/:id',
          name: 'set-acuerdo',
          component: SetObjetivos
        },
        {
          path: 'acuerdo-detail/:id',
          name: 'acuerdo-detail',
          component: AcuerdoDetail
        }
      ]
    },
    {
      path: '/mis-objetivos',
      name: 'mis-objetivos',
      component: MisObjetivos,
      beforeEnter: requireAuth,
      children: [
        {
          path: 'mi-acuerdo-detail/:id',
          name: 'mi-acuerdo-detail',
          component: AcuerdoDetail
        }
      ]
    },
    {
      path: '/reporte-feedbacks',
      name: 'reporte-feedbacks',
      component: ReporteFeedbacks,
      beforeEnter: requireAuth,
      children: [
        {
          path: 'feedback-admin/:id',
          name: 'feedback-detail-admin',
          component: FeedbackDetailAdmin
        }
      ]
    },
    {
      path: '/reporte-objetivos',
      name: 'reporte-objetivos',
      component: ReporteObjetivos,
      beforeEnter: requireAuth,
      children: [
        {
          path: 'acuerdo-detail/:id',
          name: 'acuerdo-detail-reporte',
          component: AcuerdoDetail
        }
      ]
    },
    {
      path: '/mis-meritos',
      name: 'mis-meritos',
      component: MisMeritos,
      beforeEnter: requireAuth
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter (to, from, next) {
        if (typeof FluxerService.getCurrentUser() === 'object') {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/logout',
      beforeEnter (to, from, next) {
        firebase.auth.signOut().then(() => {
          next({path: '/login'})
        })
      }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js